import { HomeComponent } from "../components/Home";

export function Home() {
  return <HomeComponent />;
}
